// e.g. in App.jsx or a small hook file
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function useSyncHtmlLang() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.resolvedLanguage || "en-GB";
  }, [i18n.resolvedLanguage]);
}
